import API_SERVICES from 'constants/app.constants';
import { isEmpty } from 'lodash';
import React from 'react'
import { Table } from 'reactstrap';
import NoDataComponent from '../NoDataComponent';
const EntityDataTable = ({ data, columns }) => {
    const formatAmount = (amount) => {
        if (typeof amount === 'number' || (typeof amount === 'string' && !isNaN(amount))) {
            const numericAmount = Number(amount);
            return `₹ ${numericAmount.toLocaleString('en-IN')}`;
        }
        return amount;
    };
    const rowsToSkipFormatting = [
        'TOL/ TNW', 
        'EBITDA / Interest (times)', 
        'Current Ratio', 
        'Debt Equity Ratio', 
        'Debtors to sales (days)', 
        'Creditors to purchases (days)', 
        'Inventory stock (Days)', 
        'Cash Conversion (in days)',
        'EBITDA %',
        'PAT %'
    ];

    const formatToTwoDecimal = (num) => {
        if (typeof num === 'number') {
          return num.toFixed(2);
        } else if (typeof num === 'string' && !isNaN(num)) {
          return parseFloat(num).toFixed(2);
        }
        return num;  // Return the original value if it's not a valid number
      };
      
    return (
        <React.Fragment>
            {!isEmpty(data) ? <div className="table-responsive react-table">

                <Table hover bordered>
                    <thead className='dark'>
                        <tr>
                            {!isEmpty(columns) && columns.map((column, index) => {
                                 const isYear = column.key !== 'title';
                                return <th className={isYear ? 'right-align' : ''} key={`index-${column.name}`}>{column.name}</th>
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {!isEmpty(data) && data.map((entity, index) => {
                            return (
                                <>
                                    <tr key={`index-${entity.key}`} className='font-weight-bold bg-light'><td colSpan={columns.length} className='font-weight-bold bg-none' color="light"><span className='font-weight-bold'>{entity.key}</span></td></tr>

                                    {!isEmpty(entity.data) && entity.data.map((row, index) => {
                                        return (
                                            <tr key={`index-${entity.key}`}>
                                                {!isEmpty(columns) && columns.map((column) => {
                                                    const isAmountColumn = column.key !== 'title';
                                                    const shouldSkipFormatting = rowsToSkipFormatting.includes(row.title);

                                                    return <td key={`index2-${row[column.key]}`} className={isAmountColumn ? 'right-align' : ''}>
                                                        {row[column.key] && row[column.key] !== null
                                                            ? (shouldSkipFormatting || entity.key == "Ratios"
                                                                ? formatToTwoDecimal(row[column.key]) 
                                                                : formatAmount(row[column.key]))
                                                            : API_SERVICES.EMPTY_VALUE}
                                                    </td>;
                                                })}
                                            </tr>
                                        )
                                    })}
                                </>
                            )
                        })}
                    </tbody>
                </Table>
            </div>:
                <NoDataComponent title='No Data' subtitle='No Data Available' />}
        </React.Fragment>
    )
}

export default EntityDataTable